import { render, staticRenderFns } from "./CommunicationListTable.vue?vue&type=template&id=b5d86cf0"
import script from "./CommunicationListTable.vue?vue&type=script&lang=js"
export * from "./CommunicationListTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports